import { PerformanceAudienceChartMetric } from '@/services/endpoints/performanceAudience';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { CHART_METRICS } from '../../constants';
import { paSegBtnActiveClass, paSegBtnClass, paSegClass } from '../PerformanceAudienceComponents';

type ChartMetricToggleProps = {
  activeMetric: PerformanceAudienceChartMetric;
  onChange: (metric: PerformanceAudienceChartMetric) => void;
  className?: string;
};

const METRIC_LABEL_KEYS: Record<PerformanceAudienceChartMetric, string> = {
  impressions: 'trend.metrics.impressions',
  clicks: 'trend.metrics.clicks',
  cost: 'trend.metrics.cost',
  ctr: 'trend.metrics.ctr',
};

export const ChartMetricToggle: FC<ChartMetricToggleProps> = ({ activeMetric, onChange, className }) => {
  const { t } = useTranslation('performanceAudience');

  return (
    <div role='tablist' aria-label={t('trend.metricsLabel')} className={twMerge(paSegClass, className)}>
      {CHART_METRICS.map((metric) => {
        const isActive = metric === activeMetric;

        return (
          <button
            key={metric}
            type='button'
            role='tab'
            aria-selected={isActive}
            onClick={() => onChange(metric)}
            className={twMerge(paSegBtnClass, isActive && paSegBtnActiveClass)}
          >
            {t(METRIC_LABEL_KEYS[metric] as 'trend.metrics.impressions')}
          </button>
        );
      })}
    </div>
  );
};
